module.exports = __webpack_public_path__ + "static/media/top-time-light-icon.89277356.svg";